
define('text!templates/bin_item.html',[],function () { return '<div class="detail segment">\n    <div class="item-c text" data-id="{{id}}"><span class="strong">{{{item}}}</span></div>\n</div>';});

